import styled from 'styled-components'

const StyledGalleryFeedSortable = styled.div`
  
`

export default StyledGalleryFeedSortable
